export default {
    info: {
        method: 'GET',
        url: '/user/:uid/recent/{time}',
        name: '获取用户信息',
    },
    addInfo: {
        method: 'POST',
        url: '/admin/course/addInfo',
        name: '新增课程信息',
    },
    updateInfo: {
        method: 'PUT',
        url: '/admin/course/updateInfo',
        name: '编辑课程信息',
    },
    anytime: {
        method: 'PUT',
        url: '/admin/course/anytime',
        name: '修改全部课程上架时间',
    },
    courseConf: {
        method: 'GET',
        url: '/admin/course/courseConf',
        name: '获取课程上架时间配置信息',
    },
    courseList: {
        method: 'POST',
        url: '/admin/course/list',
        name: '课程管理列表',
    },
    courseState: {
        method: 'PUT',
        url: '/admin/course/state',
        name: '修改课程状态',
    },
    courseTime: {
        method: 'PUT',
        url: '/admin/course/time',
        name: '修改课程上架时间',
    },
    getCourse: {
        method: 'GET',
        url: '/admin/course/{id}',
        name: '查看课程信息',
    },
    getTime: {
        method: 'POST',
        url: '/admin/course/getTime',
        name: '根据开课时间返回预计上架时间',
    },
    teacherInfo: {
        method: 'GET',
        url: '/admin/course/teacherInfo/{shopId}',
        name: '获取课程教师信息信息',
    },
    courseReserveList: {
        method: 'POST',
        url: '/admin/consume/courseReserveList',
        name: '查询课程预约名单',
    },
    periodList: {
        method: 'POST',
        url: '/admin/course/periodList',
        name: '场次信息列表',
    },
    isNumExist: {
        method: 'POST',
        url: '/admin/course/isNumExist',
        name: '课程编号是否存在',
    },
    addPeriod: {
        method: 'POST',
        url: '/admin/course/addPeriod',
        name: '新增课程场次信息',
    },
    updatePeriod: {
        method: 'PUT',
        url: '/admin/course/updatePeriod',
        name: '修改课程场次信息',
    },
    courseSessionState: {
        method: 'PUT',
        url: '/admin/course/courseSessionState',
        name: '修改课程场次上下架状态',
    },
    verify: {
        method: 'GET',
        url: '/admin/course/verify/{consumeId}',
        name: '课程核销',
    },
    // cancelVerify: {
    //     method: 'PUT',
    //     url: '/admin/course/course/uncheck',
    //     name: '课程取消核销',
    // },
}
